/**
 * Sort Feed - works on Instagram, TikTok & Facebook
 *
 * Its web-accessible resources — the whole `Icons/` tree plus a handful of per-site
 * scripts — are declared with no `use_dynamic_url`, but their `matches` are scoped to the
 * social sites the extension works on (Instagram, TikTok, YouTube, Facebook) and the
 * vendor's own sortfeed.com. They are genuinely unreachable from any other origin, so a
 * negative result off those sites says nothing. We treat Instagram as the required origin
 * and probe concrete icon files (the manifest exposes them via `Icons/*.svg` globs).
 *
 * Manifest verified against version 13.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lhiilgfanjkbombmnlfelondlfohfpfg';

export const sortFeed: ExtensionDefinition = {
  id: ID,
  name: 'Sort Feed - works on Instagram, TikTok & Facebook',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 90_000,
  requiredOrigin: 'https://www.instagram.com',
  notes:
    'Static WAR (the Icons tree) scoped to Instagram/TikTok/YouTube/Facebook and ' +
    'sortfeed.com, so only those sites can detect it. We probe concrete icons on Instagram.',
  signals: [
    {
      id: 'war-sortfeed-logo-svg',
      kind: 'web-accessible-resource',
      description:
        'Fetch Icons/sortFeedLogo.svg — a vendor-named icon, exposed via the Icons/*.svg ' +
        'glob but only to the sites the extension supports.',
      weight: 1,
      run: () => probeFetch(ID, 'Icons/sortFeedLogo.svg'),
    },
    {
      id: 'war-getpro-svg',
      kind: 'web-accessible-resource',
      description: 'Fetch Icons/getPro.svg — a second origin-scoped icon path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'Icons/getPro.svg'),
    },
    {
      id: 'war-button-save-svg',
      kind: 'web-accessible-resource',
      description:
        'Fetch Icons/ButtonIcons/save.svg — a third scoped icon, from the ButtonIcons ' +
        'subfolder, independent of the others.',
      weight: 0.5,
      run: () => probeFetch(ID, 'Icons/ButtonIcons/save.svg'),
    },
  ],
};
